import { type FunctionComponent, } from "react";
import build from "@buildmeta";

import "./VersionBadge.scss";


export declare type VersionBadgeProps = {

};


export const VersionBadge: FunctionComponent<VersionBadgeProps> = ({

}) => {

	const classes = () => [ `version-badge` ].join(" ");

	return (
		<div className={classes()}>
			<span>{build.version}</span>
		</div>
	);

}
